var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"item-certitifaction"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"information"},[_c('h3',[_vm._v(_vm._s(_vm.item.name))]),_c('h5',[_vm._v(_vm._s(_vm.item.institution))]),_c('h5',[_vm._v(_vm._s(_vm.item.year_start)+" - "+_vm._s(_vm.item.year_end)+" | "+_vm._s(_vm.item.calculate_age)+" Tahun")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }